import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Button,
  TextField,
  MenuItem,
  CircularProgress
} from '@material-ui/core'

import { compose } from 'redux'
import { connect } from 'react-redux'
import { actionGetSettingReferral, actionUpdateSettingReferral } from '../../store/actions/referral'

const priceOptions = [
  { value: 'grade_aplus', label: 'Grade A+' },
  { value: 'grade_a', label: 'Grade A' },
  { value: 'grade_bplus', label: 'Grade B+' },
  { value: 'grade_b', label: 'Grade B' },
  { value: 'grade_c', label: 'Grade C' },
  { value: 'retail', label: 'Retail' },
  { value: 'sgh', label: 'SGH' }
]

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  }
}))

const ReferralSetting = ({
  getSettingReferral,
  updateSettingReferral,
  dispatchGetSettingReferral,
  dispatchUpdateSettingReferral
}) => {
  const classes = useStyles()
  const [formState, setFormState] = useState({
    comission_precentage: '',
    price_discount: ''
  })

  useEffect(() => {
    dispatchGetSettingReferral()
  }, [dispatchGetSettingReferral])

  useEffect(() => {
    if (getSettingReferral.payload) {
      setFormState({
        comission_precentage: getSettingReferral.payload.comission_precentage !== undefined ? getSettingReferral.payload.comission_precentage : '',
        price_discount: getSettingReferral.payload.price_discount !== undefined ? getSettingReferral.payload.price_discount : ''
      })
    }
  }, [getSettingReferral.payload])

  const handleChange = event => {
    event.persist()
    setFormState(prev => ({
      ...prev,
      [event.target.name]: event.target.value
    }))
  }

  const handleSubmit = event => {
    event.preventDefault()
    dispatchUpdateSettingReferral({
      comission_precentage: Number(formState.comission_precentage),
      price_discount: formState.price_discount
    })
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item lg={8} md={10} xs={12}>
          <Card>
            <form onSubmit={handleSubmit} autoComplete="off">
              <CardHeader
                title="Pengaturan Referral"
                subheader="Atur persentase komisi referral dan harga khusus referral"
              />
              <Divider />
              <CardContent>
                {getSettingReferral.loading ? (
                  <Grid container justify="center" style={{ padding: 20 }}>
                    <CircularProgress />
                  </Grid>
                ) : (
                  <Grid container spacing={3}>
                    <Grid item md={6} xs={12}>
                      <TextField
                        fullWidth
                        label="Komisi Referral (%)"
                        name="comission_precentage"
                        onChange={handleChange}
                        type="number"
                        value={formState.comission_precentage}
                        variant="outlined"
                        inputProps={{ min: 0, max: 100, step: "any" }}
                        required
                      />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <TextField
                        fullWidth
                        label="Harga Khusus Referral"
                        name="price_discount"
                        onChange={handleChange}
                        select
                        value={formState.price_discount}
                        variant="outlined"
                        required
                      >
                        {priceOptions.map(option => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                )}
              </CardContent>
              <Divider />
              <CardActions style={{ justifyContent: 'flex-end', padding: '16px' }}>
                <Button
                  color="primary"
                  variant="contained"
                  type="submit"
                  disabled={updateSettingReferral.loading || getSettingReferral.loading}
                >
                  {updateSettingReferral.loading ? 'Menyimpan...' : 'Simpan Pengaturan'}
                </Button>
              </CardActions>
            </form>
          </Card>
        </Grid>
      </Grid>
    </div>
  )
}

ReferralSetting.propTypes = {
  history: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    getSettingReferral: {
      loading: state.referral.getSettingReferral.loading,
      payload: state.referral.getSettingReferral.payload
    },
    updateSettingReferral: {
      loading: state.referral.updateSettingReferral.loading,
      success: state.referral.updateSettingReferral.success
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchGetSettingReferral: () => dispatch(actionGetSettingReferral()),
    dispatchUpdateSettingReferral: (data) => dispatch(actionUpdateSettingReferral(data))
  }
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ReferralSetting)
